exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".questionPreview[data-v-624e608d]{padding:8px}.mobileQuestionCard[data-v-624e608d]{margin:8px;padding:0}.questionLink[data-v-624e608d]{color:inherit!important;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.questionLink[data-v-624e608d]:hover{text-decoration:inherit!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-624e608d","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/questions/QuestionCards.vue
// module id = 794
// module chunks = 0